import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson30: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson28"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Calisthenics</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson31"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">What Is Calisthenics?</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Calisthenics is the term used in the fitness industry to
                  describe workouts and exercises which rely only on the use of
                  your body weight.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  {`This includes simple movements such as pull-ups, `}
                </span>
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.calisthenics-101.co.uk/10-hard-push-up-variations-using-your-body-weight"
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      push-ups
                    </span>
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                <span>
                  , squats and dips, but there are also many more advanced,
                  gravity-defying, bodyweight exercises which make calisthenics
                  appealing to anybody looking for something impressive and
                  exciting!
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">
                  Calisthenics 101 is an online resource which can provide you
                  with everything you need to know to get started with your
                  calisthenics journey.
                </b>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Why Should You Train Calisthenics?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Calisthenics has many benefits over traditional gym workouts
                  using weights and machines. Here are just 3 of those benefits:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">#1 You can train anywhere.</b>
                <span>
                  {" "}
                  Because bodyweight exercises require very little equipment,
                  calisthenics workouts can be completed at home, in the park,
                  or at the gym. Not only does this make calisthenics more
                  accessible, it means you don’t need to pay monthly gym fees!
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`#2 Calisthenics skills are impressive and motivating. `}</b>
                <span>
                  A good day at the gym for some is adding an extra 5kg to their
                  usual bench press weight. With calisthenics, a good day means
                  achieving your first muscle-up, mastering the human flag, or
                  holding your first 10-second handstand. Learning skills is
                  much more addictive and motivating than pushing weights!
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>What is calisthenics?</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>
                Calisthenics is a type of workout that uses a person’s body
                weight with little or no equipment.
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The exercises involve movements that use large muscle groups,
                such as pushups. People typically perform these exercises at a
                moderate pace. They help to improve coordination, flexibility,
                and strength.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Calisthenics originated in Ancient Greece and remains popular
                today. Most people can perform these exercises, regardless of
                the level of their athletic ability. Many of them do not require
                any equipment.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When I first started calisthenics, I faced challenges due to a
                lack of consistency and proper guidance. Today, I'm here to help
                you start calisthenics correctly, even if you're beginning from
                scratch. We'll cover the fundamental skills, prerequisites, and
                training plans to get you on the right track.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Basic Prerequisites:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Before diving into specific skills, let's establish some
                  foundational prerequisites:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Push Day Skills: `}</b>
                  <span>Start with 10 strict form pushups.</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Pull Day Skills:</b>
                  <span className="font-dm-sans">
                    {" "}
                    Ensure you can perform three strict form pull-ups and hold a
                    dead hang for one minute.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Leg Day Skills: `}</b>
                  <span>
                    Master 20 "ass to grass" squats and three deep archer
                    squats.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Now, let's explore the skills and training plans for each
                  category:
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Push Day Skills:</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Rest for 90 seconds after every exercise in every set.3 sets
                    of each
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>{`Scapula Push-ups: `}</b>
                  <span className="font-dm-sans">8-12 reps</span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[45.31rem] h-[26.44rem] object-cover"
            alt=""
            src="/94@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Planche Lean:</b>
            <span> 10-15 seconds</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[26.88rem] object-cover"
            alt=""
            src="/95@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Hindu Pushups:</b>
            <span> 8-10 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[26.88rem] object-cover"
            alt=""
            src="/96@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Incline Pushups: `}</b>
            <span>10-12 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[27.56rem] object-cover"
            alt=""
            src="/97@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Parallel Bar Dips:</b>
            <span> 8-10 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/98@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Pike Push-Ups: `}</b>
            <span>8-10 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/99@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Side Plank:</b>
            <span> 45 seconds</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[31.25rem] object-cover"
            alt=""
            src="/101@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Hollow Body Hold: `}</b>
            <span>Max duration</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[23.56rem] object-cover"
            alt=""
            src="/102@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Diamond Push Up: `}</b>
            <span>8-12 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[14.88rem] object-cover"
            alt=""
            src="/103@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Wall Handstand:</b>
            <span> 30 seconds</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[35.06rem] object-cover"
            alt=""
            src="/104@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Pull Day Skills:</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Rest for 90 seconds after every exercise in every set.3 sets
                    of each:
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Scapula Pull-ups:</b>
                  <span className="font-dm-sans"> 6-8 reps</span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[45.13rem] h-[44.31rem] object-cover"
            alt=""
            src="/105@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Dead Hangs:</b>
            <span> 10-15 seconds</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/106@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Skin The Cats: `}</b>
            <span>1-3 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[24.38rem] object-cover"
            alt=""
            src="/107@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Tuck Lever: `}</b>
            <span>12 seconds</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[30.75rem] object-cover"
            alt=""
            src="/108@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`FL Raises: `}</b>
            <span>4-6 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[25.31rem] object-cover"
            alt=""
            src="/109@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Bodyweight Rows:</b>
            <span> 8-12 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[31.38rem] object-cover"
            alt=""
            src="/110@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Pull-ups: `}</b>
            <span>6-8 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/111@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Chin Ups: `}</b>
            <span>6-8 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/112@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Wall Handstand:</b>
            <span> 30 seconds</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[35.06rem] object-cover"
            alt=""
            src="/104@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Hollow Body Hold: `}</b>
            <span>Max duration</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[23.56rem] object-cover"
            alt=""
            src="/102@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem] text-white">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Leg Day Skills:</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Rest for 90 seconds after every exercise in every set.3 sets
                    of each:
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b className="font-dm-sans">{`Step Ups: `}</b>
                  <span>15-25 reps:</span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[45.13rem] h-[36.44rem] object-cover"
            alt=""
            src="/115@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Lunges: `}</b>
            <span>8-10 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[43.69rem] object-cover"
            alt=""
            src="/116@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Archer Squats:</b>
            <span> 8-10 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[25.75rem] object-cover"
            alt=""
            src="/1161@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Bodyweight Squats:</b>
            <span> 8-10 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[45.13rem] object-cover"
            alt=""
            src="/117@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Horse Stance:</b>
            <span> 45 seconds</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[31.63rem] object-cover"
            alt=""
            src="/1171@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Split Squats:</b>
            <span> 8-10 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[31.44rem] object-cover"
            alt=""
            src="/118@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Eccentric Pistol Squats: `}</b>
            <span>5 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[33rem] object-cover"
            alt=""
            src="/119@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Single Leg Planks:</b>
            <span> 30 seconds</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[26.06rem] object-cover"
            alt=""
            src="/120@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Hollow Body Holds: `}</b>
            <span>Max duration</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[22.56rem] object-cover"
            alt=""
            src="/121@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Calf Raises:</b>
            <span> 15-25 reps</span>
          </div>
          <img
            className="relative w-[45.13rem] h-[63.81rem] object-cover"
            alt=""
            src="/122@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Choosing Your Plan:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Based on the skills you want to master, select one of the
                  three plans: Push Day Skills, Pull Day Skills, or Leg Day
                  Skills. These plans provide a structured path to progress in
                  your calisthenics journey.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Remember, consistency, proper form, and gradual progression
                  are key to success. Start with the plan that aligns with your
                  goals and fitness level, and adapt as you advance in your
                  calisthenics training. Keep pushing yourself, stay
                  disciplined, and enjoy the journey to achieving your fitness
                  goals.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <i>Feel free to screenshot the plans for quick reference.</i>
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson31"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson30;
